import { useEffect, useRef } from 'react';
import { useLanguageStore } from '../store/languageStore';
import { useMatchStore } from '../store/matchStore';

export const useLanguageChangeListener = () => {
  const { selectedLanguage } = useLanguageStore();
  const { regenerateContentForLanguage } = useMatchStore();
  const previousLanguage = useRef<string | null>(null);

  useEffect(() => {
    // Only trigger regeneration if we have a previous language (not initial load)
    if (previousLanguage.current && previousLanguage.current !== selectedLanguage) {
      console.log(`Language changed from ${previousLanguage.current} to ${selectedLanguage}`);
      
      // Regenerate AI content for the new language
      regenerateContentForLanguage(selectedLanguage).catch(error => {
        console.error('Error regenerating content for language change:', error);
      });
    }
    
    // Update the previous language reference
    previousLanguage.current = selectedLanguage;
  }, [selectedLanguage, regenerateContentForLanguage]);
}; 